import { type GetImmutableFilters } from '~/providers/FiltersProvider';
import { getBoardIdFromPath } from '~/utils/PathUtils';

/**
 * A drilled board inside a showcase lives on `/a/{shortId}/b/{boardId}`. Without this, flatten
 * never switches `board` → `boardTree`, so Expand hides boards but nested clips stay unfetched.
 * Home/root has no `/b/` segment, so this returns `{}` and listings stay collection-scoped.
 */
export const getPublicShowcaseImmutableFilters: GetImmutableFilters = ({ asPath }) => {
  const boardId = getBoardIdFromPath(asPath);

  return boardId ? { boardId } : {};
};
